import { CaretDownIcon, CheckIcon } from '@phosphor-icons/react'
import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu'
import * as styles from './styled-dropdown-menu.css'

/** Sized to the trigger's content: 24px beside h6 labels, smaller beside a logo or smaller text. */
export const StyledExpander: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <CaretDownIcon className={styles.expander} size={size} weight="fill" />
)

export const StyledItemIndicator: React.FC = () => {
  return (
    // Force mount the indicator so the layout reserves space beside the longest label
    // even when this item isn't selected; CSS controls visibility via [data-state].
    <RadixDropdownMenu.ItemIndicator className={styles.itemIndicator} forceMount>
      <CheckIcon size={20} weight="regular" />
    </RadixDropdownMenu.ItemIndicator>
  )
}
